var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.39.91c.436-.002.839.238 1.056.626l4.39 7.837c.218.388.218.866 0 1.254l-4.39 7.837a1.21 1.21 0 01-1.055.627H5.609a1.21 1.21 0 01-1.055-.627l-4.39-7.837a1.287 1.287 0 010-1.254l4.39-7.837A1.21 1.21 0 015.609.91h8.782zm-.175 1.499H5.784L1.531 10l4.253 7.59h8.431L18.468 10l-4.253-7.591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7a3 3 0 110 6 3 3 0 010-6zm0 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  }))));
}
export default SvgMenuSetting;